import { Component } from 'react';
import { func } from 'prop-types';
import Column from './Column';
import CollapseColumn from './CollapseColumn';
import Wrapper from './Wrapper';

class CollapsingColumnLayout extends Component {
  static propTypes = {
    render: func.isRequired
  };

  render() {
    return this.props.render({
      CollapseColumn,
      Column,
      Wrapper // can be replaced by Fragment in React 16
    });
  }
}

export default CollapsingColumnLayout;
